import React, { useEffect, useState } from 'react'

import { CreateGroupBody, SelectOneGroup } from 'types/GlobalGroup'
import { getDefaultCreateGroupBody } from './types'

import { useAccounts } from 'redux/hooks/Accounts'
import { useGroupActions } from 'redux/actions/Groups'
import { useAccountSettings } from 'redux/hooks/SignedInAccount'

import Access from './sections/Access'
import Color from './sections/Color'
import Name from './sections/Name'
import Owners from './sections/Owners'
import Visibility from './sections/Visibility'

import Loading from './loading'

interface GroupSettingsFormProps {
  // if group is provided settings are updated:
  group?: SelectOneGroup | null
  // returns the current value for external control:
  onChange?: (value: CreateGroupBody) => void
  sx?: object
}

const GroupSettingsForm = (props: GroupSettingsFormProps) => {
  const { group, onChange } = props

  const { account, loading: accountLoading } = useAccountSettings()

  const [data, setData] = useState<CreateGroupBody>(
    group
      ? {
          profile_color: group.profile_color,
          show_on_home: group.show_on_home,
          is_private: group.is_private,
          name: group.name,
          owners: group.owners.map((owner) => owner.id)
        }
      : getDefaultCreateGroupBody(account)
  )

  useEffect(() => {
    if (onChange) {
      onChange(data)
    }
  }, [data, onChange])

  const { accounts, loading: accountsLoading } = useAccounts()
  const { tryUpdateGroup } = useGroupActions()

  const loading = accountsLoading || !accounts || accountLoading

  if (loading) return <Loading />

  return (
    <>
      <Name
        color={group ? group.profile_color : data.profile_color}
        onSubmit={(value) => {
          if (group) {
            // edit
            tryUpdateGroup(
              group.id,
              {
                name: value
              },
              () => {}
            )
          } else {
            // add
            setData((prevState) => ({
              ...prevState,
              name: value
            }))
          }
        }}
        value={group ? group.name : data.name}
        variant={group ? 'dialog' : 'default'}
      />

      <Color
        onSubmit={(value) => {
          if (group) {
            // edit
            tryUpdateGroup(
              group.id,
              {
                profile_color: value
              },
              () => {}
            )
          } else {
            // add
            setData((prevState) => ({
              ...prevState,
              profile_color: value
            }))
          }
        }}
        value={group ? group.profile_color : data.profile_color}
      />

      <Owners
        onSubmit={(value) => {
          if (group) {
            // edit
            tryUpdateGroup(
              group.id,
              {
                owners: value
              },
              () => {}
            )
          } else {
            // add
            setData((prevState) => ({
              ...prevState,
              owners: value
            }))
          }
        }}
        value={
          group ? group.owners.map((owner) => owner.account_id) : data.owners
        }
      />

      <Access
        onSubmit={(value) => {
          if (group) {
            // edit
            tryUpdateGroup(
              group.id,
              {
                is_private: value
              },
              () => {}
            )
          } else {
            // add
            setData((prevState) => ({
              ...prevState,
              is_private: value
            }))
          }
        }}
        value={group ? group.is_private : data.is_private}
      />

      <Visibility
        onSubmit={(value) => {
          if (group) {
            // edit
            tryUpdateGroup(
              group.id,
              {
                show_on_home: value
              },
              () => {}
            )
          } else {
            // add
            setData((prevState) => ({
              ...prevState,
              show_on_home: value
            }))
          }
        }}
        value={group ? group.show_on_home : data.show_on_home}
      />
    </>
  )
}

export default GroupSettingsForm
